'use strict';

/**
* List Item custom element.
*/
JQX('jqx-list-item', function (_JQX$ContentElement) {
    babelHelpers.inherits(Item, _JQX$ContentElement);

    function Item() {
        babelHelpers.classCallCheck(this, Item);
        return babelHelpers.possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
    }

    babelHelpers.createClass(Item, [{
        key: 'template',


        /**
        * jqx-list-item's template.
        */
        value: function template() {
            return '<div id="container">\n                   <span id=\'itemInput\' class =\'jqx-input jqx-hidden\'></span>\n                   <div id="itemContainer" inner-h-t-m-l=\'[[innerHTML]]\' class ="jqx-list-item-container"><content></content></div>\n               </div>';
        }
    }, {
        key: 'appendChild',
        value: function appendChild(node) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.appendChild.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            that.$.itemContainer.innerHTML = '';

            if (node instanceof HTMLElement) {
                that.$.itemContainer.appendChild(node);
            }
        }
    }, {
        key: 'insertBefore',
        value: function insertBefore(newNode, referenceNode) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.insertBefore.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            referenceNode.parentNode.insertBefore(newNode, referenceNode);
        }
    }, {
        key: 'removeChild',
        value: function removeChild(node) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.removeChild.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (node instanceof HTMLElement) {
                that.$.itemContainer.removeChild(node);
            }
        }

        /**
        * jqx-list-item's event listeners.
        **/

    }, {
        key: 'ready',


        /**
        * Called when the element is ready. Used for one-time configuration of the Item.
        */
        value: function ready() {
            babelHelpers.get(Item.prototype.__proto__ || Object.getPrototypeOf(Item.prototype), 'ready', this).call(this);

            var that = this;

            if (that.label !== '') {
                that.innerHTML = that.label;
            } else if (that.innerHTML !== '') {
                that.label = that.innerHTML;
            }

            that._setDisplayMode(that.displayMode);
        }

        /**
        * Called when a property is changed.
        */

    }, {
        key: 'propertyChangedHandler',
        value: function propertyChangedHandler(propertyName, oldValue, newValue) {
            var that = this;

            babelHelpers.get(Item.prototype.__proto__ || Object.getPrototypeOf(Item.prototype), 'propertyChangedHandler', this).call(this, propertyName, oldValue, newValue);

            if (propertyName === 'hidden') {
                if (!newValue) {
                    that.$.removeClass('jqx-hidden');
                } else {
                    that.$.addClass('jqx-hidden');
                }
            }

            if (propertyName === 'displayMode') {
                that._setDisplayMode(newValue);
            }

            if (propertyName === 'label') {
                var context = that.context;
                that.context = document;
                that.innerHTML = newValue;

                var listBox = that.getListBox();
                listBox.onItemUpdated(that);
                that.context = context;
            }

            if (propertyName === 'innerHTML') {
                var _listBox = that.getListBox();
                _listBox.onItemUpdated(that);
            }
        }
    }, {
        key: 'getListBox',
        value: function getListBox() {
            var that = this;

            var parent = that.parentNode;
            while (parent instanceof JQX.ListBox === false && parent !== null) {
                parent = parent.parentNode;
            }

            return parent;
        }
    }, {
        key: 'attached',
        value: function attached() {
            var that = this;

            babelHelpers.get(Item.prototype.__proto__ || Object.getPrototypeOf(Item.prototype), 'attached', this).call(this);

            that.ownerListBox = that.getListBox();

            if (that.ownerListBox) {
                that.ownerListBox.onItemAttached(that);
            }
        }
    }, {
        key: 'detached',
        value: function detached() {
            var that = this;

            babelHelpers.get(Item.prototype.__proto__ || Object.getPrototypeOf(Item.prototype), 'detached', this).call(this);

            if (that.ownerListBox) {
                that.ownerListBox.onItemDetached(that);
            }
        }
        /**
        * Item onMouseEnter event handler.
        */

    }, {
        key: '_itemOnMouseEnter',
        value: function _itemOnMouseEnter() {
            var that = this;

            if (that.disabled || !that.ownerListBox) {
                return;
            }

            that.$.addClass('hovered');
        }

        /**
          * Item onMouseMove event handler.
        */

    }, {
        key: '_itemOnMouseMove',
        value: function _itemOnMouseMove(event) {
            var that = this;

            if (that.disabled || !that.ownerListBox) {
                return;
            }

            if (JQX.ListBox.DragDrop.Dragging && that.ownerListBox.reorder && !JQX.Utilities.Core.isMobile) {
                JQX.ListBox.DragDrop.DropDetails = { item: that, position: 'top' };
                if (!that.ownerListBox._areCSSVarsSupported) {
                    if (that.ownerListBox._indexOf(that) === that.ownerListBox._items.length - 1 || that.parentNode.lastElementChild === that) {
                        var rect = that.getBoundingClientRect();
                        if (event.pageY > rect.top + rect.height / 2 - 1) {
                            JQX.ListBox.DragDrop.DropDetails = { item: that, position: 'bottom' };
                        }
                    }
                    return;
                }

                that.$.removeClass('jqx-list-item-line-feedback');
                that.$.removeClass('jqx-list-item-bottom-line-feedback');

                if (that.ownerListBox._indexOf(that) === that.ownerListBox._items.length - 1 || that.parentNode.lastElementChild === that) {
                    var _rect = that.getBoundingClientRect();
                    if (event.pageY > _rect.top + _rect.height / 2 - 1) {
                        that.$.addClass('jqx-list-item-bottom-line-feedback');
                        JQX.ListBox.DragDrop.DropDetails = { item: that, position: 'bottom' };
                    } else {
                        that.$.addClass('jqx-list-item-line-feedback');
                    }
                } else {
                    that.$.addClass('jqx-list-item-line-feedback');
                }
            }
        }

        /**
        * Item onMouseLeave event handler.
        */

    }, {
        key: '_itemOnMouseLeave',
        value: function _itemOnMouseLeave() {
            var that = this;

            if (that.disabled || !that.ownerListBox) {
                return;
            }

            if (JQX.ListBox.DragDrop.Dragging) {
                that.$.removeClass('jqx-list-item-line-feedback');
                that.$.removeClass('jqx-list-item-bottom-line-feedback');
            }

            that.$.removeClass('hovered');
        }
    }, {
        key: '_setDisplayMode',
        value: function _setDisplayMode(value) {
            var that = this;

            var listBox = that.getListBox();

            if (listBox) {
                var displayMode = listBox.selectionMode === 'checkBox' || listBox.selectionMode === 'radioButton' ? listBox.selectionMode : 'default';

                that.displayMode = value = displayMode;
            }

            if (value === 'default') {
                that.$itemInput.addClass('jqx-hidden');
                return;
            }

            that.$itemInput.removeClass('jqx-hidden');
        }
    }], [{
        key: 'properties',

        // Item's properties.
        get: function get() {
            return {
                'displayMode': {
                    allowedValues: ['default', 'checkBox', 'radioButton'],
                    value: 'default',
                    type: 'string'
                },
                'focused': {
                    value: false,
                    type: 'boolean'
                },
                'grouped': {
                    value: false,
                    type: 'boolean'
                },
                'selected': {
                    value: false,
                    type: 'boolean'
                },
                'value': {
                    value: '',
                    type: 'string'
                },
                'label': {
                    value: '',
                    type: 'string'
                },
                'group': {
                    value: '',
                    type: 'string'
                },
                'hidden': {
                    value: false,
                    type: 'boolean'
                }
            };
        }
    }, {
        key: 'listeners',
        get: function get() {
            return {
                'mouseenter': '_itemOnMouseEnter',
                'mouseleave': '_itemOnMouseLeave',
                'mousemove': '_itemOnMouseMove'
            };
        }
    }]);
    return Item;
}(JQX.ContentElement));

/**
* List Items Group custom element.
*/
JQX('jqx-list-items-group', function (_JQX$ContentElement2) {
    babelHelpers.inherits(ListItemsGroup, _JQX$ContentElement2);

    function ListItemsGroup() {
        babelHelpers.classCallCheck(this, ListItemsGroup);
        return babelHelpers.possibleConstructorReturn(this, (ListItemsGroup.__proto__ || Object.getPrototypeOf(ListItemsGroup)).apply(this, arguments));
    }

    babelHelpers.createClass(ListItemsGroup, [{
        key: 'template',


        /**
        * jqx-list-items-group's template.
        */
        value: function template() {
            return '<div id="container">\n                 <span id="itemsLabel" class ="jqx-list-items-group-label">[[label]]</span>\n                 <div id="listItemsGroupContainer" inner-h-t-m-l=\'[[innerHTML]]\' class ="jqx-list-items-group-container">\n                    <content></content>\n                 </div>\n               </div>';
        }
    }, {
        key: 'appendChild',
        value: function appendChild(node) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.appendChild.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (node instanceof HTMLElement) {
                that.$.listItemsGroupContainer.appendChild(node);
            }
        }
    }, {
        key: 'removeChild',
        value: function removeChild(node) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.removeChild.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (node instanceof HTMLElement) {
                that.$.listItemsGroupContainer.removeChild(node);
            }
        }
    }, {
        key: 'getListBox',
        value: function getListBox() {
            var that = this;

            var parent = that.parentNode;
            while (parent instanceof JQX.ListBox === false && parent !== null) {
                parent = parent.parentNode;
            }

            return parent;
        }
    }, {
        key: 'attached',
        value: function attached() {
            var that = this;

            babelHelpers.get(ListItemsGroup.prototype.__proto__ || Object.getPrototypeOf(ListItemsGroup.prototype), 'attached', this).call(this);

            if (!that.ownerListBox) {
                that.ownerListBox = that.getListBox();
            }

            if (that.ownerListBox && that.ownerListBox.onListItemsGroupAttached) {
                that.ownerListBox.onListItemsGroupAttached(that);
            }
        }
    }, {
        key: 'detached',
        value: function detached() {
            var that = this;

            babelHelpers.get(ListItemsGroup.prototype.__proto__ || Object.getPrototypeOf(ListItemsGroup.prototype), 'detached', this).call(this);

            if (that.ownerListBox && that.ownerListBox.onListItemsGroupDetached) {
                that.ownerListBox.onListItemsGroupDetached(that);
            }
        }
    }], [{
        key: 'properties',

        // Item's properties.
        get: function get() {
            return {
                'label': {
                    value: '',
                    type: 'string'
                }
            };
        }
    }]);
    return ListItemsGroup;
}(JQX.ContentElement));
/**
* List box custom element.
*/
JQX('jqx-list-box', function (_JQX$ContentElement3) {
    babelHelpers.inherits(ListBox, _JQX$ContentElement3);

    function ListBox() {
        babelHelpers.classCallCheck(this, ListBox);
        return babelHelpers.possibleConstructorReturn(this, (ListBox.__proto__ || Object.getPrototypeOf(ListBox)).apply(this, arguments));
    }

    babelHelpers.createClass(ListBox, [{
        key: '_downHandler',
        value: function _downHandler(event) {
            var that = this;

            if (that.disabled || that.displayLoadingIndicator || that.readonly) {
                return;
            }

            var target = event.originalEvent.target;
            var item = null;

            if (target instanceof JQX.ListItem && !target.disabled && !(target instanceof JQX.ListItemsGroup)) {
                item = target.dataItem;
            } else {
                while (target.parentElement) {
                    if (target instanceof JQX.ListItem && !target.disabled && !(target instanceof JQX.ListItemsGroup)) {

                        item = target.dataItem;
                        break;
                    }

                    target = target.parentElement;
                }
            }

            if (!JQX.Utilities.Core.isMobile && item) {
                that._focus(item);
                that.select(item);
            }

            JQX.ListBox.DragDrop.StartTime = new Date();
            JQX.ListBox.DragDrop.StartPosition = { left: event.pageX, top: event.pageY };

            if (item && !JQX.ListBox.DragDrop.Feedback && that.reorder) {
                JQX.ListBox.DragDrop.Feedback = document.createElement('span');
                JQX.ListBox.DragDrop.Feedback.appendChild(item.offsetHeight ? item.cloneNode(true) : that._createItem(item));
                JQX.ListBox.DragDrop.Item = item;
                JQX.Utilities.Extend(JQX.ListBox.DragDrop.Feedback).addClass('jqx-popup jqx-list-item jqx-list-item-feedback');
            }
        }
    }, {
        key: '_pointerUpHandler',
        value: function _pointerUpHandler(event) {
            var target = event.target;

            var select = function select(item) {
                var listBox = item.ownerListBox;

                if (listBox.disabled || listBox.displayLoadingIndicator || listBox.selectionMode === 'none' || item.grouped) {
                    return;
                }

                listBox._focus(item);
                listBox.select(item);
            };

            if (event.target instanceof JQX.ListItem && !event.target.disabled && !(event.target instanceof JQX.ListItemsGroup)) {
                select(target.dataItem);
                return;
            }

            while (target.parentElement) {
                if (target instanceof JQX.ListItem && !target.disabled && !(target instanceof JQX.ListItemsGroup)) {
                    select(target.dataItem);
                    break;
                }

                target = target.parentElement;
            }
        }
    }, {
        key: '_upHandler',
        value: function _upHandler(event) {
            var that = this;

            if (that.disabled || that.readonly) {
                return;
            }

            if (JQX.Utilities.Core.isMobile && !JQX.ListBox.DragDrop.Dragging) {
                var left = Math.abs(event.pageX - JQX.ListBox.DragDrop.StartPosition.left);
                var top = Math.abs(event.pageY - JQX.ListBox.DragDrop.StartPosition.top);
                var canSelect = left >= 0 && left <= 3 && top >= 0 && top <= 3;

                if (JQX.Utilities.Core.isMobile) {
                    if (new Date() - JQX.ListBox.DragDrop.StartTime >= 300) {
                        canSelect = false;
                    }
                }

                if (canSelect) {
                    that._pointerUpHandler(event.originalEvent);
                }
            }

            if (JQX.ListBox.DragDrop.Feedback) {
                if (JQX.ListBox.DragDrop.Feedback.parentNode) {
                    JQX.ListBox.DragDrop.Feedback.parentNode.removeChild(JQX.ListBox.DragDrop.Feedback);
                }
                JQX.ListBox.DragDrop.Feedback = null;

                if (JQX.Utilities.Core.isMobile && JQX.ListBox.DragDrop.Dragging) {
                    for (var j = 0; j < JQX.ListBox.DragDrop.ListBoxes.length; j++) {
                        var listBox = JQX.ListBox.DragDrop.ListBoxes[j];
                        var rect = listBox.getBoundingClientRect();

                        if (!listBox.reorder) {
                            continue;
                        }

                        if (rect.left <= event.pageX && event.pageX <= rect.right && rect.top <= event.pageY && event.pageY <= rect.bottom) {
                            for (var i = 0; i < listBox._items.length; i++) {
                                var item = listBox._items[i];
                                var itemRect = item.getBoundingClientRect();

                                if (listBox._indexOf(item) === listBox._items.length - 1 || item.parentNode.lastElementChild === item) {
                                    if (event.pageY >= itemRect.top + itemRect.height / 2 && event.pageY <= itemRect.bottom) {
                                        JQX.ListBox.DragDrop.DropDetails = { item: item, position: 'bottom' };
                                        break;
                                    }
                                }
                                if (event.pageY >= itemRect.top && event.pageY <= itemRect.bottom) {
                                    JQX.ListBox.DragDrop.DropDetails = { item: item, position: 'top' };
                                    break;
                                }
                            }
                        }
                    }
                }

                if (JQX.ListBox.DragDrop.DropDetails) {
                    var dropItem = JQX.ListBox.DragDrop.DropDetails.item;

                    dropItem.$.removeClass('jqx-list-item-line-feedback');
                    dropItem.$.removeClass('jqx-list-item-bottom-line-feedback');

                    if (JQX.ListBox.DragDrop.Item !== dropItem) {
                        var dragItem = JQX.ListBox.DragDrop.Item;

                        if (dragItem.ownerListBox.dropAction !== 'none') {
                            if (dropItem.ownerListBox !== dragItem.ownerListBox && dragItem.ownerListBox.dropAction === 'move') {
                                JQX.ListBox.DragDrop.Item.ownerListBox.removeChild(JQX.ListBox.DragDrop.Item);
                            }

                            if (dragItem.ownerListBox.dropAction === 'copy') {
                                dragItem = dragItem.cloneNode(true);
                            }

                            JQX.ListBox.DragDrop.Item.group = dropItem.group;

                            var _listBox2 = JQX.ListBox.DragDrop.DropDetails.item.ownerListBox;

                            if (JQX.ListBox.DragDrop.DropDetails.position === 'top') {
                                _listBox2.insertBefore(dragItem, dropItem);
                            } else {
                                if (dropItem.parentNode.lastElementChild === dropItem) {
                                    dropItem.parentNode.appendChild(dragItem);
                                } else {
                                    _listBox2.appendChild(dragItem, dropItem);
                                }
                            }

                            _listBox2.ensureVisible(dragItem);
                            if (_listBox2.selectionMode === 'checkBox' || _listBox2.selectionMode === 'radioButton') {
                                _listBox2._focus(dragItem);
                            } else {
                                _listBox2.clearSelection();
                                _listBox2.select(dragItem);
                            }
                        }
                    }

                    var _item = JQX.ListBox.DragDrop.Item;

                    that.$.fireEvent('reorderEnd', {
                        'position': { left: event.pageX, top: event.pageY },
                        'target': event.originalEvent.target,
                        'selected': _item.selected,
                        'disabled': _item.disabled,
                        'index': that._indexOf(_item),
                        'label': _item.label,
                        'value': _item.value
                    });
                } else {
                    var _item2 = JQX.ListBox.DragDrop.Item;

                    that.$.fireEvent('reorderEnd', {
                        'position': { left: event.pageX, top: event.pageY },
                        'target': event.originalEvent.target,
                        'selected': _item2.selected,
                        'disabled': _item2.disabled,
                        'index': that._indexOf(_item2),
                        'label': _item2.label,
                        'value': _item2.value
                    });
                }
                JQX.ListBox.DragDrop.Dragging = false;
                JQX.ListBox.DragDrop.Item = null;
                JQX.ListBox.DragDrop.DropDetails = null;
            }
            for (var _i = 0; _i < JQX.ListBox.DragDrop.ListBoxes.length; _i++) {
                var _listBox3 = JQX.ListBox.DragDrop.ListBoxes[_i];

                if (_listBox3._dragInterval) {
                    clearInterval(_listBox3._dragInterval);
                }
            }
        }
    }, {
        key: '_itemsContainerMoveHandler',
        value: function _itemsContainerMoveHandler(event) {
            var that = this;

            if (JQX.ListBox.DragDrop.Dragging) {
                that._moveHandler(event);

                event.originalEvent.preventDefault();
                event.originalEvent.stopPropagation();

                return false;
            }
        }
    }, {
        key: '_moveHandler',
        value: function _moveHandler(event) {
            if (!JQX.ListBox.DragDrop.Feedback) {
                return;
            }

            if (!JQX.ListBox.DragDrop.Dragging) {
                var left = Math.abs(event.pageX - JQX.ListBox.DragDrop.StartPosition.left);
                var top = Math.abs(event.pageY - JQX.ListBox.DragDrop.StartPosition.top);
                var timeOut = new Date() - JQX.ListBox.DragDrop.StartTime;

                var canStartDrag = left >= 5 && left <= 15 || top >= 5 && top <= 15;

                if (JQX.Utilities.Core.isMobile) {
                    if (timeOut < 300 || timeOut > 1000) {
                        canStartDrag = false;
                    }
                }

                if (canStartDrag) {
                    JQX.ListBox.DragDrop.Dragging = true;
                    JQX.ListBox.DragDrop.Feedback.style.left = 5 + event.pageX + 'px';
                    JQX.ListBox.DragDrop.Feedback.style.top = 5 + event.pageY + 'px';

                    document.body.appendChild(JQX.ListBox.DragDrop.Feedback);
                    event.preventDefault();
                    event.stopPropagation();

                    event.originalEvent.preventDefault();
                    event.originalEvent.stopPropagation();

                    var that = this;
                    var item = JQX.ListBox.DragDrop.Item;

                    that.$.fireEvent('reorderStart', {
                        'position': { left: event.pageX, top: event.pageY },
                        'target': event.originalEvent.target,
                        'selected': item.selected,
                        'disabled': item.disabled,
                        'index': that._indexOf(item),
                        'label': item.label,
                        'value': item.value
                    });
                }
            } else {
                JQX.ListBox.DragDrop.Feedback.style.left = 5 + event.pageX + 'px';
                JQX.ListBox.DragDrop.Feedback.style.top = 5 + event.pageY + 'px';

                var _loop = function _loop(i) {
                    var listBox = JQX.ListBox.DragDrop.ListBoxes[i];

                    if (listBox._dragInterval) {
                        clearInterval(listBox._dragInterval);
                    }

                    listBox._dragInterval = setInterval(function () {
                        var rect = listBox.getBoundingClientRect();

                        if (rect.left <= event.pageX && rect.left + rect.width >= event.pageX) {
                            if (event.pageY >= rect.top && event.pageY <= rect.top + 20) {
                                listBox._scrollView.scrollTop -= 2;
                            } else if (event.pageY >= rect.bottom - 20 && event.pageY <= rect.bottom) {
                                listBox._scrollView.scrollTop += 2;
                            }
                        }
                    }, 1);
                };

                for (var i = 0; i < JQX.ListBox.DragDrop.ListBoxes.length; i++) {
                    _loop(i);
                }

                event.preventDefault();
                event.stopPropagation();

                event.originalEvent.preventDefault();
                event.originalEvent.stopPropagation();

                return false;
            }
        }
    }, {
        key: '_focusHandler',
        value: function _focusHandler() {
            var that = this;
            that._focused = true;
        }
    }, {
        key: '_blurHandler',
        value: function _blurHandler() {
            var that = this;
            that._focused = false;
        }
        /**
        * ListBox's HTML template.
        */

    }, {
        key: 'template',
        value: function template() {
            return '<div id="container" class="jqx-container">\n                 <input id="filterInput" class ="jqx-hidden"  disabled="[[disabled]]" placeholder=\'[[filterInputPlaceholder]]\'>\n                 <div id="itemsContainer" class="jqx-list-items-container">\n                      <div id="placeholder" class ="jqx-placeholder">[[placeholder]]</div>\n                      <div id="itemsInnerContainer" inner-h-t-m-l=\'[[innerHTML]]\' class ="jqx-list-items-inner-container">\n                      <content></content>\n                    </div>\n                 </div>\n                 <jqx-scroll-bar id="verticalScrollBar" disabled="[[disabled]]" orientation="vertical"></jqx-scroll-bar>\n                 <jqx-scroll-bar id="horizontalScrollBar" disabled="[[disabled]]" ></jqx-scroll-bar>\n                 <div id="loadingIndicatorContainer" class ="jqx-loader-container">\n                    <span id="loadingIndicator" class="jqx-loader"></span>\n                    <span id="loadingIndicatorPlaceHolder" class ="jqx-loader-label jqx-hidden">[[loadingIndicatorPlaceholder]]</span>\n                 </div>\n                </div>';
        }
    }, {
        key: 'appendChild',
        value: function appendChild(node) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.appendChild.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (that.isVirtualized) {
                if (that._items.indexOf(node) >= -1) {
                    that._items.splice(that._items.indexOf(node), 1);
                }
                that._items.splice(that._indexOf(node), 1);
                that._items.push(node);
                that._refreshItems();
            } else {
                that.$.itemsInnerContainer.appendChild(node);
            }
        }
    }, {
        key: 'insertBefore',
        value: function insertBefore(newNode, referenceNode) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.insertBefore.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (that.isVirtualized) {
                if (that._items.indexOf(newNode) >= -1) {
                    that._items.splice(that._items.indexOf(newNode), 1);
                }
                that._items.splice(that._indexOf(referenceNode), 0, newNode);
                that._refreshItems();
            } else {
                referenceNode.parentNode.insertBefore(newNode, referenceNode);
            }
        }
    }, {
        key: 'removeChild',
        value: function removeChild(node) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.removeChild.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (that.isVirtualized) {
                that._items.splice(that._indexOf(node), 1);
                that._refreshItems();
            } else {
                if (node.parentNode) {
                    node.parentNode.removeChild(node);
                }
            }
        }

        /**
        * Updates the listbox when a property is changed.
        * @param {string} propertyName The name of the property.
        * @param {number/string} oldValue The previously entered value. Max, min and value are of type Number. The rest are of type String.
        * @param {number/string} newValue The new entered value. Max, min and value are of type Number. The rest are of type String.
        */

    }, {
        key: 'propertyChangedHandler',
        value: function propertyChangedHandler(propertyName, oldValue, newValue) {
            babelHelpers.get(ListBox.prototype.__proto__ || Object.getPrototypeOf(ListBox.prototype), 'propertyChangedHandler', this).call(this, propertyName, oldValue, newValue);

            var that = this;

            switch (propertyName) {
                case 'dataSource':
                case 'valueMember':
                case 'groupMember':
                case 'displayMember':
                    {
                        that.clearSelection();
                        that._dataBind();
                        break;
                    }
                case 'displayLoadingIndicator':
                    {
                        that._setLoadingIndicatorVisibility();
                        break;
                    }
                case 'filterable':
                    {
                        that._refreshFilter();
                        that._refreshLayout();
                        break;
                    }
                case 'grouped':
                    {
                        if (newValue) {
                            that._group();
                        } else {
                            that._ungroup();
                        }
                        that._refreshSelection();
                        that._refreshLayout();
                        break;
                    }
                case 'itemTemplate':
                    {
                        if (newValue === null || newValue === '') {
                            that._items.map(function (item) {
                                return item.innerHTML = item.label;
                            });
                            delete that._bindingDetails;
                            that._refreshLayout();
                            return;
                        }

                        if (that._handleItemTemplate(newValue)) {
                            that._items.map(function (item) {
                                return that._applyTemplate(item);
                            });
                            that._refreshLayout();
                        }

                        break;
                    }
                case 'selectedIndexes':
                case 'selectedValues':
                    {
                        that.clearSelection();
                        if (propertyName === 'selectedIndexes') {
                            for (var i = 0; i < newValue.length; i++) {
                                var index = newValue[i];
                                var item = that._items[index];

                                if (item) {
                                    that.select(item);
                                }
                            }
                        } else {
                            for (var _i2 = 0; _i2 < newValue.length; _i2++) {
                                var value = newValue[_i2];
                                var _item3 = that.getItem(value);

                                if (_item3) {
                                    that.select(_item3);
                                }
                            }
                        }
                        break;
                    }
                case 'selectionMode':
                    {
                        var displayMode = that.selectionMode === 'checkBox' || that.selectionMode === 'radioButton' ? that.selectionMode : 'default';

                        that._refreshSelection();
                        that._items.forEach(function (item) {
                            return item.displayMode = displayMode;
                        });
                        that._recycle();
                        break;
                    }
                case 'sorted':
                    {
                        if (newValue) {
                            that._sort();
                        } else {
                            that._unsort();
                        }

                        that._refreshSelection();
                        that._refreshLayout();
                        break;
                    }
            }
        }

        /**
        * refreshes selection items.
        */

    }, {
        key: '_refreshSelection',
        value: function _refreshSelection() {
            var that = this;

            if (!that._items || that._items.length === 0) {
                return;
            }

            var selectedValues = that.selectedValues;

            that.selectedIndexes = [];
            that.selectedValues = [];

            for (var i = 0; i < that._items.length; i++) {
                var item = that._items[i];

                item.selected = false;

                if (selectedValues.indexOf(item.value) >= 0) {
                    that._select(item, true);
                }
            }

            that._recycle();
        }

        /**
          * Unselects all items.
          */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            var that = this;

            if (!that._items || that._items.length === 0) {
                return;
            }

            for (var i = 0; i < that.selectedIndexes.length; i++) {
                var index = that.selectedIndexes[i];

                that._items[index].selected = false;
            }

            that.selectedIndexes = [];
            that.selectedValues = [];

            that._recycle();
        }
    }, {
        key: 'ensureVisible',
        value: function ensureVisible(item) {
            var that = this;

            if (typeof item === 'string') {
                item = that.getItem(item);
                if (!item) {
                    return false;
                }
            }

            if (item.top <= that._scrollView.scrollTop || item.top + item.height >= that._scrollView.scrollTop + that.offsetHeight) {
                that._scrollView.scrollTop = item.top;

                if (!that.isVirtualized) {
                    that.$.itemsContainer.scrollTop = that._scrollView.scrollTop;
                }
            }

            if (that._indexOf(item) === 0) {
                that._scrollView.scrollTop = 0;
                if (!that.isVirtualized) {
                    that.$.itemsContainer.scrollTop = that._scrollView.scrollTop;
                }
            } else if (that._indexOf(item) === that._items.length - 1) {
                that._scrollView.scrollTop = that._scrollView.scrollHeight;
                if (!that.isVirtualized) {
                    that.$.itemsContainer.scrollTop = that._scrollView.scrollTop;
                }
            }

            return true;
        }
        /**
        * Returns an array with the items from the list.
        */

    }, {
        key: 'ready',


        /**
        * ListBox ready method.
        */
        value: function ready() {
            babelHelpers.get(ListBox.prototype.__proto__ || Object.getPrototypeOf(ListBox.prototype), 'ready', this).call(this);
            var that = this;

            that._checkMissingModules();
            that._areCSSVarsSupported = JQX.Utilities.Core.CSSVariablesSupport();
            that._keysPressed = {};
            that._incrementalSearchQuery = '';
            that._incrementalSearchItems = [];
            that._previousEntry = '';
            that.isUpdating = 0;

            that._scrollView = new JQX.Utilities.Scroll(that, that.$.horizontalScrollBar, that.$.verticalScrollBar);
            that._scrollView.hScrollBar.$.addClass('jqx-hidden');
            that._scrollView.vScrollBar.$.addClass('jqx-hidden');

            that.setFocusable(true);
            that._setLoadingIndicatorVisibility();
            that._refreshFilter();

            that._initializeInnerHTML();
            that._dataBind();
        }
    }, {
        key: 'attached',
        value: function attached() {
            var that = this;

            babelHelpers.get(ListBox.prototype.__proto__ || Object.getPrototypeOf(ListBox.prototype), 'attached', this).call(this);

            if (!JQX.ListBox.DragDrop) {
                JQX.ListBox.DragDrop = { ListBoxes: [] };
            }

            JQX.ListBox.DragDrop.ListBoxes.push(that);
        }
    }, {
        key: 'detached',
        value: function detached() {
            var that = this;

            babelHelpers.get(ListBox.prototype.__proto__ || Object.getPrototypeOf(ListBox.prototype), 'detached', this).call(this);

            if (JQX.ListBox.DragDrop && JQX.ListBox.DragDrop.ListBoxes) {
                var index = JQX.ListBox.DragDrop.ListBoxes.indexOf(that);
                JQX.ListBox.DragDrop.ListBoxes.splice(index, 1);
            }
        }
    }, {
        key: '_createItem',
        value: function _createItem(item, index, recycling) {
            var that = this;

            var displayMode = that.selectionMode === 'checkBox' || that.selectionMode === 'radioButton' ? that.selectionMode : 'default';
            var htmlItem = recycling ? {} : document.createElement('jqx-list-item');

            htmlItem.ownerListBox = that;

            if (typeof item === 'number') {
                item = '' + item;
            }

            var getMemberValue = function getMemberValue(memberName, defaultMemberName) {
                if (item[memberName] !== undefined) {
                    return '' + item[memberName];
                }

                return item[defaultMemberName];
            };

            var label = typeof item === 'string' ? item : getMemberValue(that.displayMember, 'label');
            var value = typeof item === 'string' ? item : getMemberValue(that.valueMember, 'value');
            var group = getMemberValue(that.groupMember, 'group');

            if (undefined === label) {
                if (index !== undefined) {
                    label = '' + index;
                } else {
                    label = '';
                }
            }

            htmlItem.label = htmlItem.innerHTML = '' + label;

            if (undefined === value) {
                if (index !== undefined) {
                    value = '' + index;
                } else {
                    value = label;
                }
            }

            htmlItem.value = '' + value;
            htmlItem.displayMode = displayMode;
            htmlItem.selected = item.selected ? item.selected : false;
            htmlItem.disabled = item.disabled ? item.disabled : false;

            if (item.title) {
                htmlItem.title = item.title;
            }

            if (group) {
                htmlItem.group = '' + group;
            }

            return htmlItem;
        }
    }, {
        key: '_initializeRecyclingItems',
        value: function _initializeRecyclingItems() {
            var that = this;

            if (!that.dataSource || that.dataSource && that.dataSource.length === 0 || !that.isVirtualized) {
                return;
            }

            var itemsHeight = 0;
            var listBoxHeight = that.offsetHeight;

            that.$.itemsInnerContainer.innerHTML = '';
            that._recyclingItems = [];

            for (var i = 0; i < that.dataSource.length; i++) {
                var item = that.dataSource[i];
                var htmlItem = that._createItem(item);

                if (that.itemHeight && that.itemHeight !== 'auto') {
                    htmlItem.style.height = that.itemHeight + 'px';
                }

                that.$.itemsInnerContainer.appendChild(htmlItem);

                itemsHeight += htmlItem.offsetHeight;

                htmlItem.dataItem = that._items[i];
                that._recyclingItems.push(htmlItem);

                if (itemsHeight > 1.5 * listBoxHeight) {
                    break;
                }
            }
        }
    }, {
        key: '_dataBind',
        value: function _dataBind() {
            var that = this;

            if (that.dataSource !== null) {
                that.isUpdating++;

                var initializeDataBoundItems = function initializeDataBoundItems(fragment) {
                    that._items = [];
                    that._groups = [];

                    for (var i = 0; i < that.dataSource.length; i++) {
                        var item = that.dataSource[i];
                        var htmlItem = fragment ? that._createItem(item, i) : that._createItem(item, i, true);

                        htmlItem.dataIndex = i;
                        htmlItem.dataItem = htmlItem;

                        that._items[i] = htmlItem;

                        if (fragment) {
                            fragment.appendChild(htmlItem);
                        }
                    }
                };

                if (that.isVirtualized) {
                    initializeDataBoundItems();
                    that._initializeRecyclingItems();
                } else {
                    var fragment = document.createDocumentFragment();

                    that.$.itemsInnerContainer.innerHTML = '';

                    initializeDataBoundItems(fragment);

                    that.$.itemsInnerContainer.appendChild(fragment);
                }

                that.isUpdating--;
            }

            var items = that.querySelectorAll('jqx-list-item');
            var itemsReady = function itemsReady() {
                that.isUpdating++;

                if (!that.dataSource) {
                    that._initializeHtmlListItems();
                    that._initializeHtmlListGroups();
                }

                if (that.grouped) {
                    that._group();
                }

                if (that.sorted) {
                    that._sort();
                }

                that._refreshLayout();

                that._initializeSelection();
                that.isInitialized = true;

                that.isUpdating--;
            };

            if (items.length === 0) {
                itemsReady();
            } else {
                that._ensureItemsReady(items, itemsReady);
            }
        }
    }, {
        key: '_ensureItemsReady',
        value: function _ensureItemsReady(nodes, callback) {
            var that = this;

            var contextCallback = function contextCallback() {
                var setContext = function setContext(context) {
                    for (var i = 0; i < nodes.length; i++) {
                        nodes[i].context = context === 'node' ? nodes[i] : document;
                    }
                };

                setContext('node');
                callback();
                setContext();
            };

            if (nodes.length === 0) {
                contextCallback();
            } else {
                that._nodesReadyListeners = 0;

                for (var i = 0; i < nodes.length; i++) {
                    var node = nodes[i];

                    var readyEventHandler = function () {
                        that._nodesReadyListeners--;
                        if (that._nodesReadyListeners === 0) {
                            contextCallback();

                            delete that._nodesReadyListeners;
                        }
                    }.bind(that);

                    if (!node.isCompleted) {
                        that._nodesReadyListeners++;
                        node.onCompleted = readyEventHandler;
                    }
                }

                if (that._nodesReadyListeners === 0) {
                    contextCallback();
                }
            }
        }
    }, {
        key: '_initializeInnerHTML',
        value: function _initializeInnerHTML() {
            var that = this;

            if (that.$.itemsInnerContainer.innerHTML.indexOf('<option') >= 0) {
                that.$.itemsInnerContainer.innerHTML = that.$.itemsInnerContainer.innerHTML.replace(/<optgroup/ig, '<jqx-list-items-group').replace(/<\/optgroup/ig, '<\/jqx-list-items-group').replace(/<option/ig, '<jqx-list-item').replace(/<\/option/ig, '<\/jqx-list-item');
            } else if (that.$.itemsInnerContainer.innerHTML.indexOf('<ul') >= 0) {
                that.$.itemsInnerContainer.innerHTML = that.$.itemsInnerContainer.innerHTML.replace(/<ul/ig, '<jqx-list-items-group').replace(/<\/ul/ig, '<\/jqx-list-items-group').replace(/<li/ig, '<jqx-list-item').replace(/<\/li/ig, '<\/jqx-list-item');
            }
        }
    }, {
        key: '_initializeHtmlListItems',
        value: function _initializeHtmlListItems() {
            var that = this;

            var htmlItems = that.querySelectorAll('jqx-list-item');
            var displayMode = that.selectionMode === 'checkBox' || that.selectionMode === 'radioButton' ? that.selectionMode : 'default';

            var getMemberValue = function getMemberValue(item, memberName, defaultMemberName) {
                if (item[memberName] !== undefined) {
                    return '' + item[memberName];
                }

                return item[defaultMemberName];
            };

            that._items = [];

            var top = 0;

            for (var i = 0; i < htmlItems.length; i++) {
                var item = htmlItems[i];

                item.dataIndex = i;
                item.label = item.innerHTML;
                item.dataItem = item;

                if (!item.top) {
                    item.top = top;
                }

                if (!item.height) {
                    item.height = item.offsetHeight;
                }

                top += item.height;

                if (!item.value) {
                    item.value = '' + i;
                }

                var label = getMemberValue(item, that.displayMember, 'label');
                var value = getMemberValue(item, that.valueMember, 'value');
                var group = getMemberValue(item, that.groupMember, 'group');

                if (item.label !== label) {
                    item.label = label;
                }

                if (item.value !== value) {
                    item.value = value;
                }

                if (item.group !== group) {
                    item.group = group;
                }

                item.displayMode = displayMode;

                if (item.selected) {
                    that.selectedIndexes.push(i);
                    that.selectedValues.push(item.value);
                }

                that._items.push(item);
            }

            if (that.itemTemplate && that._handleItemTemplate(that.itemTemplate)) {
                that._items.map(function (item) {
                    return that._applyTemplate(item);
                });
            }
        }
    }, {
        key: '_group',
        value: function _group() {
            var that = this;

            that.isUpdating++;

            var groups = [];
            var items = [];

            if (that.sorted) {
                that._unsort();
            }

            for (var i = 0; i < that._items.length; i++) {
                var item = that._items[i];
                var label = item.group || item.innerHTML.toUpperCase().charAt(0) || item.label.toUpperCase().charAt(0);

                if (!groups[label]) {
                    groups[groups.length++] = groups[label] = { items: [item], label: label };
                } else {
                    groups[label].items.push(item);
                }
            }

            if (!that.isVirtualized) {
                while (that.$.itemsInnerContainer.firstChild) {
                    that.$.itemsInnerContainer.removeChild(that.$.itemsInnerContainer.firstChild);
                }

                var fragment = document.createDocumentFragment();

                that._groups = [];

                for (var _i3 = 0; _i3 < groups.length; _i3++) {
                    var group = groups[_i3];
                    var groupElement = document.createElement('jqx-list-items-group');

                    groupElement.label = group.label;
                    groupElement.dataIndex = _i3;

                    for (var j = 0; j < groups[_i3].items.length; j++) {
                        var _item4 = group.items[j];

                        items.push(_item4);

                        groupElement.appendChild(_item4);
                    }

                    that._groups.push(groupElement);

                    fragment.appendChild(groupElement);
                }

                that._items = items;
                that.$.itemsInnerContainer.appendChild(fragment);
            } else {
                that._groups = [];

                for (var _i4 = 0; _i4 < groups.length; _i4++) {
                    var _group2 = groups[_i4];
                    _group2.dataIndex = _i4;
                    _group2.grouped = true;
                    _group2.hidden = false;
                    _group2.displayMode = 'default';

                    items.push(_group2);

                    for (var _j = 0; _j < groups[_i4].items.length; _j++) {
                        var _item5 = _group2.items[_j];

                        _item5.ownerGroup = _group2;
                        items.push(_item5);
                    }
                }

                that._groups = groups;
                that._items = items;
            }

            if (that.sorted) {
                that._sort();
            }

            that.isUpdating--;
        }
    }, {
        key: '_ungroup',
        value: function _ungroup() {
            var that = this;

            that.isUpdating++;

            that._groups = [];
            that._unsort();

            var items = [];

            if (!that.isVirtualized) {
                var fragment = document.createDocumentFragment();

                for (var i = 0; i < that._items.length; i++) {
                    var item = that._items[i];

                    fragment.appendChild(item);
                    items.push(item);
                }

                if (items.length > 0) {
                    that.$.itemsInnerContainer.innerHTML = '';
                    that.$.itemsInnerContainer.appendChild(fragment);
                }
            } else {
                for (var _i5 = 0; _i5 < that._items.length; _i5++) {
                    var _item6 = that._items[_i5];

                    if (_item6.grouped) {
                        continue;
                    }

                    items.push(_item6);
                }
            }

            that._items = items;

            if (that.sorted) {
                that._sort();
            }

            that.isUpdating--;
        }
    }, {
        key: '_initializeHtmlListGroups',
        value: function _initializeHtmlListGroups() {
            var that = this;
            var htmlListItemsGroups = that.$.itemsInnerContainer.querySelectorAll('jqx-list-items-group');

            that._groups = [];

            for (var i = 0; i < htmlListItemsGroups.length; i++) {
                var group = htmlListItemsGroups[i];
                group.dataIndex = i;

                that._groups.push(group);
            }
        }
    }, {
        key: '_initializeSelection',
        value: function _initializeSelection() {
            var that = this;

            if (that.selectionMode === 'one' || that.selectionMode === 'oneOrMany' || that.selectionMode === 'default') {
                if (that.selectedIndexes.length === 0 && that._items.length > 0) {
                    that.selectedIndexes.push(0);
                    that.selectedValues.push(that._items[0].value);
                }
            }

            var selectedIndexes = that.selectedIndexes.slice(0);
            var selectedValues = that.selectedValues.slice(0);

            that.clearSelection();

            for (var i = 0; i < that._items.length; i++) {
                var item = that._items[i];

                if (selectedIndexes.indexOf(i) >= 0 || selectedValues.indexOf(item.value || item.label) >= 0) {
                    if (that._focusedItem) {
                        that._focusedItem.focused = false;
                    }
                    that._focusedItem = null;
                    that.select(item);
                }
            }
        }
    }, {
        key: 'onItemUpdated',
        value: function onItemUpdated() {
            var that = this;

            if (!that.isInitialized || that.isUpdating > 0) {
                return;
            }

            that._refreshLayout();
        }
    }, {
        key: '_refreshItems',
        value: function _refreshItems() {
            var that = this;

            if (!that.isInitialized || that.isUpdating > 0) {
                return;
            }

            that.isUpdating++;

            if (that.grouped) {
                that._ungroup();
            } else if (that.sorted) {
                that._unsort();
            }

            if (!that.isVirtualized) {
                that._items = [];

                var items = that.querySelectorAll('jqx-list-item');

                for (var i = 0; i < items.length; i++) {
                    items[i].dataIndex = i;
                    that._items.push(items[i]);
                }
            }

            if (that.grouped) {
                that._group();
            } else if (that.sorted) {
                that._sort();
            }

            that._refreshLayout();
            that.isUpdating--;
        }
    }, {
        key: 'onItemAttached',
        value: function onItemAttached() {
            var that = this;

            that._refreshItems();
        }
    }, {
        key: 'onItemDetached',
        value: function onItemDetached() {
            var that = this;

            that._refreshItems();
        }

        /**
        * Incremental Search logic.
        */

    }, {
        key: '_applyIncrementalSearch',
        value: function _applyIncrementalSearch(key) {
            var that = this;
            if (that.incrementalSearchDelay === null || isNaN(that.incrementalSearchDelay)) {
                return;
            }

            if (['Shift', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Control', 'Home', 'End', 'PageUp', 'PageDown'].indexOf(key) > -1) {
                return;
            }

            if (that._incrementalSearchQuery.indexOf(key) !== 0) {
                that._incrementalSearchQuery += key;
            }

            if (that._incrementalSearchTimer) {
                clearTimeout(that._incrementalSearchTimer);
            }

            that._incrementalSearch();
            that._incrementalSearchTimer = setTimeout(function () {
                that._incrementalSearchQuery = '';
            }, that.incrementalSearchDelay);
            return;
        }

        /**
        * Selects an item by its HTML Element or Value.
        */

    }, {
        key: 'select',
        value: function select(item) {
            var that = this;

            if (typeof item === 'string') {
                item = that.getItem(item);
                if (!item) {
                    return;
                }
            }
            if (typeof item === 'number') {
                item = that.getItem(item);
                if (!item) {
                    return;
                }
            }

            if (item.grouped) {
                return;
            }

            if (!that._focusedItem && that.selectionMode !== 'none') {
                that._focusedItem = item;
                item.focused = true;
            }

            switch (that.selectionMode) {
                case 'one':
                    if (that.selectedIndexes.length === 1 && that.selectedIndexes[0] === that._indexOf(item)) {
                        return false;
                    }

                    if (that.selectedIndexes.length >= 1) {
                        that.clearSelection();
                    }

                    that._select(item);
                    return true;
                case 'zeroOrOne':
                    if (that.selectedIndexes.length === 1 && that.selectedIndexes[0] === that._indexOf(item)) {
                        that.clearSelection();
                        return true;
                    }

                    if (that.selectedIndexes.length >= 1) {
                        that.clearSelection();
                    }

                    that._select(item);
                    return true;
                case 'radioButton':
                    if (that.$.itemsInnerContainer.querySelectorAll('jqx-list-items-group').length > 0) {
                        var group = that._focusedItem.parentNode;

                        if (!item.selected) {
                            for (var index in group.children) {
                                var _item7 = group.children[index];

                                if (_item7.selected) {
                                    that.unselect(_item7);
                                }
                            }

                            that._select(item);
                        }

                        return true;
                    } else if (that.isVirtualized && that._groups.length > 0) {
                        var _group3 = that._focusedItem.ownerGroup;

                        if (!item.selected) {
                            for (var _index in _group3.items) {
                                var _item8 = _group3.items[_index];

                                if (_item8.selected) {
                                    that.unselect(_item8);
                                }
                            }

                            that._select(item);
                        }

                        return true;
                    }

                    if (!item.selected) {
                        if (that.selectedIndexes.length >= 1) {
                            that.clearSelection();
                        }

                        that._select(item);
                    }

                    return true;
                case 'oneOrMany':
                    if (!item.selected) {
                        that._select(item);
                    } else if (that.selectedIndexes.length > 1) {
                        that.unselect(item);
                    }
                    return true;
                case 'zeroOrMany':
                case 'checkBox':
                    if (!item.selected) {
                        that._select(item);
                    } else {
                        that.unselect(item);
                    }
                    return true;
                case 'default':
                    {
                        if (that._keysPressed['Control']) {
                            if (that.selectedIndexes.length > 1) {
                                if (item.selected) {
                                    that.unselect(item);
                                    that._focus(that._items[that.selectedIndexes[0]]);
                                } else {
                                    that._select(item);
                                }
                            } else {
                                that._select(item);
                            }
                            return true;
                        }

                        if (that._keysPressed['Shift']) {
                            var selectedItem = that._items[that.selectedIndexes[0]];
                            var _index2 = void 0;

                            that.clearSelection();
                            that._select(selectedItem);

                            if (that._indexOf(selectedItem) > that._indexOf(item)) {
                                _index2 = that._indexOf(selectedItem) - 1;
                                while (_index2 >= that._indexOf(item)) {
                                    that._select(that._items[_index2]);
                                    _index2--;
                                }
                            } else {
                                _index2 = that._indexOf(selectedItem) + 1;
                                while (_index2 <= that._indexOf(item)) {
                                    that._select(that._items[_index2]);
                                    _index2++;
                                }
                            }
                            return true;
                        }

                        that.clearSelection();
                        that._select(item);
                        return true;
                    }
            }

            return false;
        }

        /**
        * Returns the contents of the template with the new content applied.
        */

    }, {
        key: '_applyTemplate',
        value: function _applyTemplate(item, refreshLayout) {
            var that = this;

            if (that.itemTemplate === null) {
                return;
            }

            if (!that._bindingDetails || that._bindingDetails.length === 0) {
                return;
            }

            var bindingsCount = that._bindingDetails.length;
            var clone = document.importNode(that._template.content, true),
                bindingHolderElement = void 0,
                bindingStringsCount = void 0;

            for (var b = 0; b < bindingsCount; b++) {
                bindingHolderElement = clone.childNodes[that._bindingDetails[b].childNodeIndex];
                bindingStringsCount = that._bindingDetails[b].bindingString.length;
                for (var i = 0; i < bindingStringsCount; i++) {
                    bindingHolderElement.innerHTML = bindingHolderElement.innerHTML.replace(that._bindingDetails[b].bindingString[i], item.label);
                }
            }

            item.innerHTML = '';
            for (var _i6 = 0; _i6 < clone.childNodes.length; _i6++) {
                if (clone.childNodes[_i6].outerHTML) {
                    item.innerHTML += clone.childNodes[_i6].outerHTML;
                }
            }

            if (refreshLayout === false) {
                return;
            }

            if (that._scrollHeightTimer) {
                clearInterval(that._scrollHeightTimer);
                that._scrollHeightCounter = 0;
            }

            that._scrollHeightTimer = setInterval(function () {
                if (that._lastScrollHeight !== that.$.itemsInnerContainer.scrollHeight || that._scrollHeightCounter === 10) {
                    that._refreshLayout();
                    clearInterval(that._scrollHeightTimer);
                }
                that._lastScrollHeight = that.$.itemsInnerContainer.scrollHeight;
                that._scrollHeightCounter++;
            }, 50);
        }

        /**
        * Throws an error if some necessary modules have not been loaded.
        */

    }, {
        key: '_checkMissingModules',
        value: function _checkMissingModules() {
            var missingModules = [];

            if (JQX.ScrollBar === undefined) {
                missingModules.push('jqxscrollbar.js');
            }

            if (missingModules.length > 0) {
                var that = this;

                that.error(that.localize('missingReference', { elementType: that.nodeName.toLowerCase(), files: missingModules.join(', ') }));
            }
        }

        /**
         * Filter items.
         */

    }, {
        key: '_filterItems',
        value: function _filterItems() {
            var that = this;
            var items = that._items;
            var filterQuery = that.$.filterInput.value;

            if (items.length === 0) {
                return;
            }

            var filteredItems = that._queryItems(filterQuery, that.filterMode);

            for (var i = 0; i < items.length; i++) {
                items[i].hidden = true;
            }

            for (var _i7 = 0; _i7 < filteredItems.length; _i7++) {
                var item = filteredItems[_i7];

                item.hidden = false;
            }

            if (that.grouped && that.isVirtualized) {
                for (var _i8 = 0; _i8 < that._groups.length; _i8++) {
                    var group = that._groups[_i8];
                    var _items = group.items;

                    var canHide = true;

                    for (var j = 0; j < _items.length; j++) {
                        if (!_items[j].hidden) {
                            canHide = false;
                        }
                    }

                    if (canHide) {
                        group.hidden = true;
                    }
                }
            }

            if (that.grouped && !that.isVirtualized) {
                for (var _i9 = 0; _i9 < that._groups.length; _i9++) {
                    var _ref;

                    var _group4 = that._groups[_i9];
                    var _items2 = (_ref = []).concat.apply(_ref, babelHelpers.toConsumableArray(_group4.querySelectorAll('jqx-list-item')));

                    var _canHide = true;

                    for (var _j2 = 0; _j2 < _items2.length; _j2++) {
                        if (!_items2[_j2].$.hasClass('jqx-hidden')) {
                            _canHide = false;
                        }
                    }

                    if (_canHide) {
                        _group4.$.addClass('jqx-hidden');
                    } else {
                        _group4.$.removeClass('jqx-hidden');
                    }
                }
            }

            that._filteredItems = filteredItems;
            that._refreshLayout();
            that._refreshSelection();
        }

        /**
        * Returns the next item in the list.
        */

    }, {
        key: '_getNextItem',
        value: function _getNextItem(activeItemIndex) {
            var that = this,
                items = that._items,
                itemsCount = that._items.length;
            var index = Math.max(activeItemIndex + 1, 0);

            while (index < itemsCount) {
                var item = items[index];

                if (!item.disabled && !item.hidden && !item.grouped) {
                    return item;
                }

                index++;
            }

            return items[activeItemIndex];
        }

        /**
        * Returns the previous item in the list.
        */

    }, {
        key: '_getPreviousItem',
        value: function _getPreviousItem(activeItemIndex) {
            var that = this,
                items = that._items;
            var index = Math.max(activeItemIndex - 1, 0);

            while (index > -1) {
                var item = items[index];

                if (!item.disabled && !item.hidden && !item.grouped) {
                    return item;
                }

                index--;
            }

            return items[activeItemIndex];
        }

        /**
        * Calculates the width/height of the items.
        */

    }, {
        key: 'update',
        value: function update(index, details) {
            var that = this;
            var htmlItem = that._items[index];

            if (htmlItem) {
                if (typeof details === 'string') {
                    htmlItem.label = details;
                    if (undefined === htmlItem.value) {
                        htmlItem.value = details;
                    }
                } else {
                    for (var detail in details) {
                        htmlItem[detail] = details[detail];
                    }
                }

                if (that.sorted || that.grouped || that.isVirtualized) {
                    that._refreshItems();
                }
            } else {
                that.error(that.localize('indexOutOfBound', { elementType: that.nodeName.toLowerCase(), method: 'update' }));
            }
        }
    }, {
        key: 'insert',
        value: function insert(index, items) {
            var that = this;

            if (!index) {
                index = 0;
            }

            if (items instanceof Array) {
                that.isUpdating++;
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    var htmlItem = that._createItem(item);
                    if (index >= that._items.length || that._items.length === 0) {
                        that.appendChild(htmlItem);
                    } else {
                        that.insertBefore(htmlItem, that._items[index]);
                    }
                }
                that.isUpdating--;
                that._refreshItems();
            } else {
                var _htmlItem = that._createItem(items);

                if (index >= that._items.length || that._items.length === 0) {
                    that.appendChild(_htmlItem);
                } else {
                    that.insertBefore(_htmlItem, that._items[index]);
                }
            }
        }
    }, {
        key: 'remove',
        value: function remove(index) {
            var that = this;
            var htmlItem = that._items[index];

            if (htmlItem) {
                if (that.isVirtualized) {
                    that._items.splice(index, 1);
                    that._refreshItems();
                } else {
                    htmlItem.parentNode.removeChild(htmlItem);
                }
            } else {
                that.error(that.localize('indexOutOfBound', { elementType: that.nodeName.toLowerCase(), method: 'remove' }));
            }
        }

        /**
          * Update all matched cases from the filter input.
          */

    }, {
        key: '_queryItems',
        value: function _queryItems(searchQuery, searchMode) {
            var that = this;
            var result = [];
            var findItem = function findItem(item, filterQuery) {
                if (item.grouped) {
                    return item;
                }

                switch (searchMode) {
                    case 'startsWith':
                        if (item.label.indexOf(filterQuery) === 0) {
                            return item;
                        }
                        break;
                    case 'startsWithIgnoreCase':
                        if (item.label.toLowerCase().indexOf(filterQuery.toLowerCase()) === 0) {
                            return item;
                        }
                        break;
                    case 'none':
                        if (item.label.indexOf(filterQuery) < 0) {
                            return item;
                        }
                        break;
                    case 'contains':
                        if (item.label.indexOf(filterQuery) > -1) {
                            return item;
                        }
                        break;
                    case 'containsIgnoreCase':
                        if (item.label.toLowerCase().indexOf(filterQuery.toLowerCase()) > -1) {
                            return item;
                        }
                        break;
                    case 'equals':
                        if (item.label.localeCompare(filterQuery) === 0) {
                            return item;
                        }
                        break;
                    case 'equalsIgnoreCase':
                        if (item.label.toLowerCase().localeCompare(filterQuery.toLowerCase()) === 0) {
                            return item;
                        }
                        break;
                    case 'endsWith':
                        if (item.label.endsWith(filterQuery)) {
                            return item;
                        }
                        break;
                    case 'endsWithIgnoreCase':
                        if (item.label.toLowerCase().endsWith(filterQuery.toLowerCase())) {
                            return item;
                        }
                        break;
                }

                return null;
            };

            if (searchQuery.length === 0) {
                return that._items;
            }

            for (var i = 0; i < that._items.length; i++) {
                var item = findItem(that._items[i], searchQuery);

                if (item) {
                    result.push(item);
                }
            }

            return result;
        }
    }, {
        key: '_select',
        value: function _select(item, preventEvent) {
            var that = this;
            var selectedIndex = that.selectedIndexes.indexOf(that._indexOf(item));
            var indexes = that.selectedIndexes.slice(0),
                values = that.selectedValues.slice(0);

            item.selected = true;

            if (selectedIndex === -1) {
                indexes.push(that._indexOf(item));
                values.push(item.value || item.label);
            } else {
                that._recycle();
                return false;
            }

            that.selectedIndexes = indexes;
            that.selectedValues = values;
            that._recycle();

            if (!that.isCompleted || preventEvent) {
                return;
            }

            that.$.fireEvent('change', {
                'selected': item.selected,
                'disabled': item.disabled,
                'index': that._indexOf(item),
                'label': item.label,
                'value': item.value
            });

            return true;
        }
    }, {
        key: 'unselect',
        value: function unselect(item) {
            var that = this;

            if (typeof item === 'string') {
                item = that.getItem(item);
                if (!item) {
                    return;
                }
            }

            var selectedIndex = that.selectedIndexes.indexOf(that._indexOf(item));
            var indexes = that.selectedIndexes.slice(0),
                values = that.selectedValues.slice(0);

            item.selected = false;

            if (selectedIndex >= 0) {
                indexes.splice(selectedIndex, 1);
                values.splice(selectedIndex, 1);
            } else {
                return false;
            }

            that.selectedIndexes = indexes;
            that.selectedValues = values;

            if (!that.isCompleted) {
                return;
            }

            that.$.fireEvent('change', {
                'selected': item.selected,
                'disabled': item.disabled,
                'index': that._indexOf(item),
                'label': item.label,
                'value': item.value
            });

            that._recycle();

            return true;
        }

        /**
        * Validates the template and if valid, returns an object with binding details.
        */

    }, {
        key: '_handleItemTemplate',
        value: function _handleItemTemplate(template) {

            if (template === null || !template) {
                return;
            }

            var that = this;

            if (!('content' in document.createElement('template'))) {
                that.error(that.localize('htmlTemplateNotSuported', { elementType: that.nodeName.toLowerCase() }));
                that.itemTemplate = null;
                return;
            }

            template = document.getElementById(template);
            if (template === null || !('content' in template)) {
                that.error(that.localize('invalidTemplate', { elementType: that.nodeName.toLowerCase(), property: 'itemTemplate' }));
                that.itemTemplate = null;
                return;
            }

            var templateContent = template.content,
                childrenCount = templateContent.childNodes.length,
                regex = /{{\w+}}/g;
            var bindingString = void 0,
                bindingsFound = void 0;

            that._bindingDetails = [];
            that._template = template;
            for (var i = 0; i < childrenCount; i++) {
                bindingsFound = [];
                while (bindingString = regex.exec(templateContent.childNodes[i].innerHTML)) {
                    bindingsFound.push(bindingString[0]);
                }

                if (bindingsFound.length > 0) {
                    that._bindingDetails.push({ childNodeIndex: i, bindingString: bindingsFound });
                }
            }

            return true;
        }

        /**
        * Handles pressed keys.
        */

    }, {
        key: '_handleKeyStrokes',
        value: function _handleKeyStrokes(key) {
            var that = this;
            var toFocus = that.selectionMode === 'radioButton' || that.selectionMode === 'checkBox' || that.selectionMode === 'zeroOrMany' || that.selectionMode === 'oneOrMany';
            var items = that._items;

            if (that.filterable && that.$.filterInput.value.length > 0) {
                items = that._filteredItems;
            }

            if (that.disabled || that.readonly) {
                return;
            }

            switch (key) {
                case 'ArrowLeft':
                case 'ArrowUp':
                    that._handleArrowKeys(true);
                    break;
                case 'ArrowRight':
                case 'ArrowDown':
                    that._handleArrowKeys(false);
                    break;
                case ' ':
                    {
                        if (that.selectedIndexes.length < 1 && !that._focusedItem) {
                            return;
                        }

                        var focusedItem = that._focusedItem ? that._focusedItem : that._items[that.selectedIndexes[that.selectedIndexes.length - 1]];

                        var makeSelection = function makeSelection(item) {
                            if (item.selected && that.selectionMode !== 'radioButton') {
                                that.unselect(item);
                            } else {
                                that.select(item);
                            }
                        };

                        if (that.selectionMode === 'oneOrMany') {
                            if (focusedItem.selected && that.selectedIndexes.length > 1) {
                                makeSelection(focusedItem);
                            } else if (!focusedItem.selected) {
                                makeSelection(focusedItem);
                            }
                            return;
                        }

                        makeSelection(focusedItem);
                        break;
                    }
                case 'Home':
                    {
                        if (items.length === 0) {
                            return;
                        }

                        if (toFocus) {
                            that._focus(items[0]);
                        } else {
                            if (!that._keysPressed['Shift']) {
                                that.clearSelection();
                            }
                            that.select(items[0]);
                            that._focus(items[0]);
                        }
                        that._scrollView.scrollTop = 0;
                        break;
                    }
                case 'End':
                    {
                        if (items.length === 0) {
                            return;
                        }

                        if (toFocus) {
                            that._focus(items[items.length - 1]);
                        } else {
                            if (!that._keysPressed['Shift']) {
                                that.clearSelection();
                            }
                            that.select(items[items.length - 1]);
                            that._focus(items[items.length - 1]);
                        }
                        that._scrollView.scrollTop = that._scrollView.scrollHeight;
                        break;
                    }
                case 'PageUp':
                    {
                        that._pageUpKeyHandler(items);
                        break;
                    }
                case 'PageDown':
                    {
                        that._pageDownKeyHandler(items);
                        break;
                    }
            }

            that._recycle();
        }
        /**
        * Horizontal Scroll Bar handler
        */

    }, {
        key: '_horizontalScrollbarHandler',
        value: function _horizontalScrollbarHandler(event) {
            var that = this;

            event.stopPropagation();

            if (that.isVirtualized) {
                that._recycle();
            } else {
                that.$.itemsContainer.scrollLeft = event.detail.value;
            }
        }
    }, {
        key: '_unsort',
        value: function _unsort() {
            var that = this;

            that.isUpdating++;

            var sortByIndex = function sortByIndex(a, b) {
                var indexA = a.dataIndex;
                var indexB = b.dataIndex;

                if (indexA < indexB) {
                    return -1;
                }
                if (indexA > indexB) {
                    return 1;
                }

                return 0;
            };

            if (!that.isVirtualized) {
                if (that._groups.length > 0) {
                    that._groups.sort(sortByIndex);

                    var sortedItems = [];

                    for (var i = 0; i < that._groups.length; i++) {
                        var _ref2;

                        var group = that._groups[i];
                        var items = (_ref2 = []).concat.apply(_ref2, babelHelpers.toConsumableArray(group.querySelectorAll('jqx-list-item')));

                        items.sort(sortByIndex);
                        sortedItems = sortedItems.concat(items);
                    }

                    that._items = sortedItems;
                } else {
                    that._items.sort(sortByIndex);
                }

                that._applySortOrder();
            } else {
                if (that._groups.length > 0) {
                    that._groups.sort(sortByIndex);

                    var _sortedItems = [];

                    for (var _i10 = 0; _i10 < that._groups.length; _i10++) {
                        var _ref3;

                        var _group5 = that._groups[_i10];
                        var _items3 = (_ref3 = []).concat.apply(_ref3, babelHelpers.toConsumableArray(_group5.items));

                        _items3.sort(sortByIndex);

                        _sortedItems.push(_group5);
                        _sortedItems = _sortedItems.concat(_items3);
                    }

                    that._items = _sortedItems;
                } else {
                    that._items.sort(sortByIndex);
                }
            }

            that.isUpdating--;
        }
    }, {
        key: '_applySortOrder',
        value: function _applySortOrder() {
            var that = this;

            var reorder = function reorder(items) {
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    var parentNode = item.parentNode;

                    if (!parentNode) {
                        continue;
                    }

                    parentNode.appendChild(item);
                }
            };

            reorder(that._items);
            reorder(that._groups);
        }
    }, {
        key: '_sort',
        value: function _sort() {
            var that = this;

            that.isUpdating++;

            var sortByLabel = function sortByLabel(a, b) {
                var labelA = a.label;
                var labelB = b.label;

                if (labelA < labelB) {
                    return -1;
                }
                if (labelA > labelB) {
                    return 1;
                }

                return 0;
            };

            that._groups.sort(sortByLabel);

            if (!that.isVirtualized) {
                if (that._groups.length > 0) {
                    var sortedItems = [];
                    for (var i = 0; i < that._groups.length; i++) {
                        var _ref4;

                        var group = that._groups[i];
                        var items = (_ref4 = []).concat.apply(_ref4, babelHelpers.toConsumableArray(group.querySelectorAll('jqx-list-item')));

                        items.sort(sortByLabel);
                        sortedItems = sortedItems.concat(items);
                    }

                    that._items = sortedItems;
                } else {
                    that._items.sort(sortByLabel);
                }

                that._applySortOrder();
            } else {
                if (that._groups.length > 0) {
                    var _sortedItems2 = [];
                    for (var _i11 = 0; _i11 < that._groups.length; _i11++) {
                        var _ref5;

                        var _group6 = that._groups[_i11];
                        var _items4 = (_ref5 = []).concat.apply(_ref5, babelHelpers.toConsumableArray(_group6.items));

                        _sortedItems2.push(_group6);
                        _items4.sort(sortByLabel);
                        _sortedItems2 = _sortedItems2.concat(_items4);
                    }

                    that._items = _sortedItems2;
                } else {
                    that._items.sort(sortByLabel);
                }
            }

            that.isUpdating--;
        }
    }, {
        key: 'getItem',
        value: function getItem(value) {
            var that = this;

            for (var i = 0; i < that._items.length; i++) {
                if (that._items[i].value === value) {
                    return that._items[i];
                }
            }

            return null;
        }
    }, {
        key: '_focus',
        value: function _focus(item) {
            var that = this;

            if (that.selectionMode === 'none' || that.disabled || that.readonly) {
                return;
            }

            if (that._focusedItem) {
                that._focusedItem.focused = false;
            }

            that._focusedItem = item;
            that._focusedItem.focused = true;
        }

        /**
         * KeyDown handler.
         */

    }, {
        key: '_keyDownHandler',
        value: function _keyDownHandler(event) {
            var that = this;

            if (that.disabled || that.readonly) {
                return;
            }

            if (that.filterable && that.$.filterInput === document.activeElement) {
                return;
            }

            if (!that._focused) {
                return;
            }

            event.stopPropagation();

            if (that._items.length === 0 || that.disabled || that.selectionMode === 'none' || that.displayLoadingIndicator) {
                return;
            }

            if (that.filterable) {
                switch (event.key) {
                    case 'ArrowLeft':
                    case 'ArrowRight':
                        return;
                    case 'ArrowUp':
                    case 'ArrowDown':
                        event.preventDefault();
                }
            }

            that._applyIncrementalSearch(event.key);
            if (['Shift', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Control', ' ', 'Home', 'End', 'PageUp', 'PageDown'].indexOf(event.key) < 0) {
                return;
            }

            if (!that._focusedItem && that._items.length > 0) {
                that.select(that._items[0]);
                return;
            }

            switch (that.selectionMode) {
                case 'one':
                case 'zeroOrOne':
                    if (event.key === 'Shift' || event.key === 'Control' || event.key === ' ') {
                        return;
                    }

                    that._handleKeyStrokes(event.key);
                    break;
                case 'oneOrMany':
                case 'zeroOrMany':
                case 'radioButton':
                case 'checkBox':
                    if (event.key === 'Shift' || event.key === 'Control') {
                        return;
                    }

                    that._handleKeyStrokes(event.key);
                    break;
                case 'default':
                    if (event.key === ' ') {
                        return;
                    }

                    that._keysPressed[event.key] = event.type === 'keydown';
                    that._handleKeyStrokes(event.key);
                    break;
            }
        }

        /**
        * KeyUp handler.
        */

    }, {
        key: '_keyUpHandler',
        value: function _keyUpHandler(event) {
            var that = this;

            if (that.filterable && that.$.filterInput === document.activeElement) {
                if (that._filterTimer) {
                    clearTimeout(that._filterTimer);
                }

                that._filterTimer = setTimeout(function () {
                    that._filterItems();
                    that._scrollView.scrollTop = that.$.itemsContainer.scrollTop = 0;
                    that._scrollView.scrollLeft = that.$.itemsContainer.scrollLeft = 0;
                }, 300);
                return;
            }

            if (!that._focused) {
                return;
            }

            if (that._focusedItem && that._focusedItem.hidden) {
                if (that._filteredItems.length > 0) {
                    var itemToFocus = that._filteredItems[0];

                    if (itemToFocus.grouped && that._filteredItems.length > 1) {
                        itemToFocus = that._filteredItems[1];
                    }
                    that._focus(itemToFocus);
                    that._recycle();
                }
            }

            event.stopPropagation();
            event.preventDefault();

            if (that.disabled) {
                return;
            }

            if (['Shift', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Control', ' ', 'PageUp', 'PageDown'].indexOf(event.key) < 0) {
                return;
            }

            that._keysPressed[event.key] = false;
        }

        /**
        * Container mousewheel event handler.
        */

    }, {
        key: '_mouseWheelHandler',
        value: function _mouseWheelHandler(event) {
            var that = this;

            if (that._scrollView.hScrollBar.$.hasClass('jqx-hidden') && that._scrollView.vScrollBar.$.hasClass('jqx-hidden')) {
                return;
            }

            if (!that.disabled && !that._scrollView.vScrollBar.$.hasClass('jqx-hidden')) {
                event.stopPropagation();
                event.preventDefault();
                that._scrollView.scrollTop += event.deltaY < 0 ? -100 : 100;
            }
        }

        /**
        * Page Down key handler.
        */

    }, {
        key: '_pageDownKeyHandler',
        value: function _pageDownKeyHandler(items) {
            var that = this;

            if (items.length === 0) {
                return;
            }

            var selectedItem = that._items[that.selectedIndexes[that.selectedIndexes.length - 1]];
            if (that.selectionMode === 'checkBox' || that.selectionMode === 'radioButton' || that.selectionMode === 'zeroOrMany' || that.selectionMode === 'oneOrMany') {
                if (that._focusedItem) {
                    selectedItem = that._focusedItem;
                }
            }

            var item = void 0;
            var selectedItemIndex = that._indexOf(selectedItem);
            var viewTop = selectedItem.top + that.$.itemsContainer.offsetHeight - selectedItem.height;

            for (var i = selectedItemIndex; i < items.length; i++) {
                if (items[i].top >= viewTop) {
                    item = items[i];
                    break;
                }
            }

            if (!item) {
                item = items[items.length - 1];
            }

            if (that.selectionMode === 'checkBox' || that.selectionMode === 'radioButton' || that.selectionMode === 'zeroOrMany' || that.selectionMode === 'oneOrMany') {
                that._focus(item);
            } else {
                if (!item.selected) {
                    if (!that._keysPressed['Shift']) {
                        that.clearSelection();
                    }
                    that.select(item);
                }
            }

            if (item.height + item.top > that.$.itemsContainer.scrollTop + that.$.itemsContainer.offsetHeight || item.top < that.$.itemsContainer.scrollTop) {
                that._scrollView.scrollTop = item.top - that.$.itemsContainer.offsetHeight + item.height;
            }
        }

        /**
        * Page Up key handler.
        */

    }, {
        key: '_pageUpKeyHandler',
        value: function _pageUpKeyHandler(items) {
            var that = this;

            if (items.length === 0) {
                return;
            }

            var selectedItem = that._items[that.selectedIndexes[that.selectedIndexes.length - 1]];

            if (that.selectionMode === 'checkBox' || that.selectionMode === 'radioButton' || that.selectionMode === 'zeroOrMany' || that.selectionMode === 'oneOrMany') {
                if (that._focusedItem) {
                    selectedItem = that._focusedItem;
                }
            }

            var viewTop = selectedItem.top - that.$.itemsContainer.offsetHeight;
            var selectedItemIndex = that._indexOf(selectedItem);
            var item = void 0;

            for (var i = selectedItemIndex; i > 0; i--) {
                if (items[i].top <= viewTop) {
                    item = items[i];
                    break;
                }
            }

            if (!item) {
                item = items[0];
            }

            if (that.selectionMode === 'checkBox' || that.selectionMode === 'radioButton' || that.selectionMode === 'zeroOrMany' || that.selectionMode === 'oneOrMany') {
                that._focus(item);
            } else {
                if (!item.selected) {
                    if (!that._keysPressed['Shift']) {
                        that.clearSelection();
                    }
                    that.select(item);
                }
            }

            that._scrollView.scrollTop = item.top;

            var itemIndex = that._indexOf(item);

            if (itemIndex === 0) {
                that._scrollView.scrollTop = 0;
            }
        }

        /**
        * Removes all items from DOM. 
        */

    }, {
        key: 'clearItems',
        value: function clearItems() {
            var that = this;

            that.$.itemsInnerContainer.innerHTML = '';
            that._items = [];
            that.clearSelection();
        }

        /**
        * List Box resize handler.
        */

    }, {
        key: '_resizeHandler',
        value: function _resizeHandler(event) {
            var that = this;

            if (event.target === that && !that._isUpdatingScrollBars) {
                that._isUpdatingScrollBars = true;
                that._initializeRecyclingItems();
                that._refreshLayout();
                that._isUpdatingScrollBars = false;
            }
        }
    }, {
        key: '_indexOf',
        value: function _indexOf(item) {
            var that = this;

            if (!item) {
                return -1;
            }

            var index = that._items.indexOf(item);

            if (index === -1) {
                index = that._items.indexOf(that.getItem(item.value));
            }

            return index;
        }

        /**
        * Search items.
        */

    }, {
        key: '_incrementalSearch',
        value: function _incrementalSearch() {
            var that = this;
            var canSelect = that.selectionMode !== 'radioButton' && that.selectionMode !== 'checkBox' && that.selectionMode !== 'zeroOrMany' && that.selectionMode !== 'oneOrMany';

            var searchQuery = void 0;
            var i = 0;

            switch (that.incrementalSearchMode) {
                case 'containsIgnoreCase':
                case 'equalsIgnoreCase':
                case 'startsWithIgnoreCase':
                case 'endsWithIgnoreCase':
                    searchQuery = that._incrementalSearchQuery.toLowerCase();
                    break;
                default:
                    searchQuery = that._incrementalSearchQuery;
                    break;
            }

            var select = function select(item) {
                if (item.grouped) {
                    return;
                }

                if (canSelect) {
                    if (that.selectedIndexes.length > 0) {
                        that.clearSelection();
                    }
                    that._focus(item);
                    that.select(item);
                } else {
                    that._focus(item);
                }

                //Move the scrollBar when item is out of view
                if (item.height + item.top > that.$.itemsContainer.scrollTop + that.$.itemsContainer.offsetHeight || item.top < that._scrollView.scrollTop) {
                    that._scrollView.scrollTop = item.top;
                }
                if (that._indexOf(item) === 0) {
                    that._scrollView.scrollTop = 0;
                }
                if (that._indexOf(item) === that._items.length - 1) {
                    that._scrollView.scrollTop = that._scrollView.scrollHeight;
                }
            };

            if (that._previousEntry.localeCompare(searchQuery) !== 0) {
                that._incrementalSearchItems = that._queryItems(that._incrementalSearchQuery, that.incrementalSearchMode);
                delete that._itemPosition;
            }

            //Previously entered string.
            that._previousEntry = searchQuery;

            var foundItemsCount = that._incrementalSearchItems.length;

            if (foundItemsCount === 0) {
                return;
            }

            if (foundItemsCount === 1) {
                select(that._incrementalSearchItems[0]);
                return;
            }

            if (that._itemPosition !== undefined) {
                if (that._itemPosition < foundItemsCount - 1) {
                    i = that._itemPosition;
                } else {
                    i = 0;
                    if (canSelect) {
                        that._incrementalSearchItems[that._itemPosition].selected = false;
                        that.selectedIndexes = [];
                        that.selectedValues = [];
                    } else {
                        that._incrementalSearchItems[that._itemPosition].focused = false;
                    }
                }
            } else if (canSelect) {
                that.clearSelection();
            }

            for (i; i < foundItemsCount; i++) {
                if (that._incrementalSearchItems[i].selected && canSelect) {
                    that._incrementalSearchItems[i].selected = false;
                    that.selectedIndexes = [];
                    that.selectedValues = [];
                    continue;
                }
                if (!canSelect && that._incrementalSearchItems[i].focused) {
                    that._incrementalSearchItems[i].focused = false;
                    continue;
                }
                select(that._incrementalSearchItems[i]);
                that._itemPosition = i;
                return;
            }
        }

        /**
        * Document select start handler.
        */

    }, {
        key: '_selectStartHandler',
        value: function _selectStartHandler(event) {
            if (this.$.filterInput === document.activeElement) {
                return;
            }

            event.preventDefault();
        }

        /**
        * Sets an item active via Keyboard.
        */
        /**
        * Sets an item active via Keyboard.
        */

    }, {
        key: '_handleArrowKeys',
        value: function _handleArrowKeys(isArrowUp) {
            var that = this;
            var canSelect = that.selectionMode !== 'radioButton' && that.selectionMode !== 'checkBox' && that.selectionMode !== 'zeroOrMany' && that.selectionMode !== 'oneOrMany';

            if (that.disabled || that.readonly) {
                return;
            }

            var focusedItemIndex = void 0;

            if (that._focusedItem && !that._keysPressed['Shift']) {
                focusedItemIndex = that._indexOf(that._focusedItem);
                that._focusedItem.focused = false;
            } else if (that.selectedIndexes.length !== 0) {
                focusedItemIndex = that.selectedIndexes[that.selectedIndexes.length - 1];
            } else {
                return;
            }

            var focusedItem = isArrowUp ? that._getPreviousItem(focusedItemIndex) : that._getNextItem(focusedItemIndex);

            that._focus(focusedItem);

            if (canSelect) {
                if (that._keysPressed['Shift']) {
                    that.select(focusedItem);
                } else if (that._items[focusedItemIndex] !== focusedItem) {
                    that.clearSelection();
                    that.select(focusedItem);
                }
            }

            that.ensureVisible(focusedItem);
        }
        /**
        * Enable/Disable the filter input component.
        */

    }, {
        key: '_refreshFilter',
        value: function _refreshFilter() {
            var that = this;

            if (that.filterable) {
                that.$.filterInput.disabled = that.disabled || that.displayLoadingIndicator ? true : false;
                that.$filterInput.removeClass('jqx-hidden');
                that.$itemsContainer.addClass('filter');
                return;
            }

            that.$.filterInput.disabled = true;
            that.$filterInput.addClass('jqx-hidden');
            that.$itemsContainer.removeClass('filter');
        }

        /**
        * Set tabIndex.
        */

    }, {
        key: 'setFocusable',
        value: function setFocusable(focusable) {
            var that = this;

            if (that.disabled || !focusable) {
                that.removeAttribute('tabindex');
                return;
            }

            that.tabIndex = 0;
        }

        /**
        * Set Loading Indicator Visibility
        */

    }, {
        key: '_setLoadingIndicatorVisibility',
        value: function _setLoadingIndicatorVisibility() {
            var that = this;

            if (that.displayLoadingIndicator) {
                that.$loadingIndicatorContainer.hasClass('jqx-visibility-hidden') ? that.$loadingIndicatorContainer.removeClass('jqx-visibility-hidden') : that.$loadingIndicatorContainer.removeClass('jqx-hidden');

                return;
            }

            //Check for old browsers.
            that._areCSSVarsSupported ? that.$loadingIndicatorContainer.addClass('jqx-hidden') : that.$loadingIndicatorContainer.addClass('jqx-visibility-hidden');
        }

        /**
        * Sets the initial scroll bar sizes.
        */

    }, {
        key: '_refreshLayout',
        value: function _refreshLayout() {
            var that = this;
            var source = that._items;

            that.__scrollHeight = null;
            that.__scrollWidth = null;

            if (!source || source === null || source.length === 0) {
                that._scrollView.hScrollBar.$.addClass('jqx-hidden');
                that._scrollView.vScrollBar.$.addClass('jqx-hidden');
                that.$itemsContainer.removeClass('hscroll');
                that.$itemsContainer.removeClass('vscroll');
                that.$filterInput.removeClass('vscroll');
                that.$placeholder.removeClass('jqx-hidden');
                if (that.isVirtualized) {
                    that._recycle();
                }
                return;
            }

            that.$placeholder.addClass('jqx-hidden');

            var hScrollWidth = that._scrollWidth - that.$.itemsContainer.offsetWidth;
            var vScrollHeight = that._scrollHeight;

            that._refreshHorizontalScrollBarVisibility(hScrollWidth);
            that._refreshVerticalScrollBarVisibility(vScrollHeight);

            if (!that._scrollView.vScrollBar.$.hasClass('jqx-hidden')) {
                hScrollWidth = that._scrollWidth - that.$.itemsContainer.offsetWidth;
                that._refreshHorizontalScrollBarVisibility(hScrollWidth);
                if (!that._scrollView.hScrollBar.$.hasClass('jqx-hidden')) {
                    that._scrollView.hScrollBar.$.addClass('bottom-right-visible');
                    that._scrollView.vScrollBar.$.addClass('bottom-right-visible');
                    that.__scrollHeight += that._scrollView.hScrollBar.offsetHeight;
                    that._scrollView.scrollHeight = that.__scrollHeight;
                } else {
                    that._scrollView.vScrollBar.$.removeClass('bottom-right-visible');
                    that._scrollView.hScrollBar.$.removeClass('bottom-right-visible');
                }

                if (that.isVirtualized) {
                    that._recycle();
                }
                return;
            }

            hScrollWidth = that._scrollWidth - that.$.itemsContainer.offsetWidth;
            that._refreshHorizontalScrollBarVisibility(hScrollWidth);

            if (!that._scrollView.hScrollBar.$.hasClass('jqx-hidden')) {
                that._scrollView.scrollHeight = that._scrollHeight;
                that._refreshVerticalScrollBarVisibility(vScrollHeight);
                if (!that._scrollView.vScrollBar.$.hasClass('jqx-hidden')) {
                    that._scrollView.hScrollBar.$.addClass('bottom-right-visible');
                    that._scrollView.vScrollBar.$.addClass('bottom-right-visible');
                } else {
                    that._scrollView.vScrollBar.$.removeClass('bottom-right-visible');
                    that._scrollView.hScrollBar.$.removeClass('bottom-right-visible');
                }
            }
            if (that.isVirtualized) {
                that._recycle();
            }
        }

        /**
        * Style change event.
        */

    }, {
        key: '_styleChangedHandler',
        value: function _styleChangedHandler() {
            var that = this;

            that._refreshLayout();
        }

        /**
        * SwipeLeft event handler.
        **/

    }, {
        key: '_swipeLeftHandler',
        value: function _swipeLeftHandler() {}

        /**
        * SwipeRight event handler.
        */

    }, {
        key: '_swipeRightHandler',
        value: function _swipeRightHandler() {}

        /**
        * Enable/Disable Horizontal Scroll bar.
        */

    }, {
        key: '_refreshHorizontalScrollBarVisibility',
        value: function _refreshHorizontalScrollBarVisibility(scrollWidth) {
            var that = this;

            that._scrollView.scrollWidth = scrollWidth;
            if (scrollWidth > 0) {
                that._scrollView.scrollLeft = that.$.itemsContainer.scrollLeft;
                that.$itemsContainer.addClass('hscroll');
                that._scrollView.hScrollBar.$.removeClass('jqx-hidden');
            } else {
                that._scrollView.hScrollBar.$.addClass('jqx-hidden');
                that.$itemsContainer.removeClass('hscroll');
            }
        }

        /**
        * Enable/Disable Vertical Scroll bar.
        */

    }, {
        key: '_refreshVerticalScrollBarVisibility',
        value: function _refreshVerticalScrollBarVisibility(scrollHeight) {
            var that = this;

            that._scrollView.scrollHeight = scrollHeight;

            if (scrollHeight > 0) {
                that._scrollView.vScrollBar.$.removeClass('jqx-hidden');
                that.$itemsContainer.addClass('vscroll');
                that.$filterInput.addClass('vscroll');
            } else {
                that._scrollView.vScrollBar.$.addClass('jqx-hidden');
                that.$itemsContainer.removeClass('vscroll');
                that.$filterInput.removeClass('vscroll');
            }
        }

        /**
        * Validates Template properties.
        */

    }, {
        key: '_validateTemplate',
        value: function _validateTemplate(property, template) {
            if (template === null || !template) {
                return;
            }

            var that = this;

            if (!('content' in document.createElement('template'))) {
                that.error(that.localize('htmlTemplateNotSuported', { elementType: that.nodeName.toLowerCase() }));
                that[property] = null;
                return;
            }

            template = document.getElementById(template);
            if (template === null || !('content' in template)) {
                that.error(that.localize('invalidTemplate', { elementType: that.nodeName.toLowerCase(), property: property }));
                that[property] = null;
                return;
            }

            return template;
        }
    }, {
        key: '_getItemIndexByPosition',
        value: function _getItemIndexByPosition(position) {
            var that = this;

            var getItemIndex = function getItemIndex(items) {
                var bottomPointer = 0;
                var topPointer = items.length - 1;

                if (position <= 0) {
                    return 0;
                }

                var lastNode = items[items.length - 1];

                if (lastNode.top <= position) {
                    return items.length - 1;
                }

                var condition = true;

                while (condition) {
                    var midPointer = Math.floor((bottomPointer + topPointer) / 2);
                    var currentitem = items[midPointer];
                    if (that._isItemInPosition(currentitem, position)) {
                        return midPointer;
                    } else if (currentitem.top < position) {
                        bottomPointer = midPointer + 1;
                    } else if (currentitem.top > position) {
                        topPointer = midPointer - 1;
                    }
                }
            };

            var items = that.filterable && that.$.filterInput.value.length > 0 ? that._filteredItems : that._items;
            var index = getItemIndex(items);

            return index;
        }
    }, {
        key: '_isItemInPosition',
        value: function _isItemInPosition(item, position) {
            var topPixel = item.top;
            var bottomPixel = item.top + item.height;
            var pixelInRow = topPixel <= position && bottomPixel > position;

            return pixelInRow;
        }
    }, {
        key: '_recycle',
        value: function _recycle() {
            var that = this;

            if (!that._recyclingItems) {
                return;
            }

            var height = that._height;
            if (!that._height) {
                height = that._height = that.$.itemsContainer.offsetHeight;
            }

            var j = 0;

            var value = that._scrollView.scrollTop;
            var itemIndex = that._getItemIndexByPosition(value);
            var items = that.filterable && that.$.filterInput.value.length > 0 ? that._filteredItems : that._items;
            var item = items[itemIndex];

            var itemTop = item ? item.top : 0;
            that.$.itemsInnerContainer.style.left = -that._scrollView.scrollLeft + 'px';
            that.$.itemsInnerContainer.style.top = -value + itemTop + 'px';

            that.isUpdating++;

            if (itemIndex >= 0) {
                for (var i = itemIndex; i < items.length; i++) {
                    var _item9 = items[i];

                    if (_item9.height === 0) {

                        continue;
                    }

                    if (itemTop + _item9.height >= value && itemTop <= value + height) {
                        var listItem = that._recyclingItems[j++];

                        listItem.dataItem = _item9;
                        listItem.label = _item9.label;
                        listItem.value = _item9.value;
                        listItem.selected = _item9.selected;
                        listItem.focused = _item9.focused;
                        listItem.hidden = _item9.hidden;
                        listItem.grouped = _item9.grouped;
                        if (_item9.title) {
                            listItem.title = _item9.title;
                        } else {
                            listItem.title = '';
                        }

                        if (!_item9.grouped) {
                            listItem.displayMode = _item9.displayMode;
                        } else {
                            listItem.displayMode = 'default';
                        }

                        if (that._scrollView.scrollWidth > 0) {
                            listItem.style.width = that.$.itemsInnerContainer.offsetWidth + that._scrollView.scrollWidth + 'px';
                        }

                        if (that.itemTemplate && that._handleItemTemplate(that.itemTemplate)) {
                            that._applyTemplate(listItem, false);
                        }
                    } else {
                        break;
                    }
                    itemTop += _item9.height;
                }
            }

            if (j < that._recyclingItems.length) {
                for (var _i12 = j; _i12 < that._recyclingItems.length; _i12++) {
                    var _listItem = that._recyclingItems[j++];

                    _listItem.hidden = true;
                }
            }

            that.isUpdating--;
        }
        /**
        * Vertical Scroll Bar handler
        */

    }, {
        key: '_verticalScrollbarHandler',
        value: function _verticalScrollbarHandler(event) {
            var that = this;
            var value = event.detail.value;
            event.stopPropagation();

            if (that.isVirtualized) {
                that._recycle();
            } else {
                that.$.itemsContainer.scrollTop = value;
            }

            if (event.context.max === event.context.value) {
                that.$.fireEvent('scrollBottomReached');
                return;
            }

            if (event.context.min === event.context.value) {
                that.$.fireEvent('scrollTopReached');
            }
        }
    }, {
        key: 'items',
        get: function get() {
            var that = this;

            if (that._filteredItems) {
                return that._filteredItems;
            }

            return that._items;
        }
    }, {
        key: '_scrollHeight',
        get: function get() {
            var that = this;

            var scrollHeight = 0;

            if (that.isVirtualized) {
                if (that.__scrollHeight) {
                    return that.__scrollHeight;
                }

                if (that._items.length === 0) {
                    return 0;
                }

                that.isUpdating++;

                var measureItem = that._createItem(that.dataSource[0]);
                that.$.itemsInnerContainer.appendChild(measureItem);

                for (var i = 0; i < that._items.length; i++) {
                    var item = that._items[i];

                    if (item.hidden) {
                        item.height = 0;
                        item.top = scrollHeight;
                        continue;
                    }

                    if (!that.itemHeight) {
                        measureItem.label = item.label;
                        item.height = measureItem.offsetHeight;
                    } else {
                        if (that.itemHeight < 30) {
                            that.itemHeight = 30;
                        }

                        item.height = that.itemHeight;
                    }

                    item.top = scrollHeight;
                    scrollHeight += item.height;
                }

                that.$.itemsInnerContainer.removeChild(measureItem);
                that.__scrollHeight = scrollHeight - that.offsetHeight;
                if (that.filterable) {
                    that.__scrollHeight += that.$.filterInput.offsetHeight;
                }

                scrollHeight = that.__scrollHeight;
                that.isUpdating--;
            } else {
                for (var _i13 = 0; _i13 < that._items.length; _i13++) {
                    var _item10 = that._items[_i13];

                    if (_item10.hidden) {
                        _item10.height = 0;
                        _item10.top = scrollHeight;
                        continue;
                    }

                    if (!that.itemHeight) {
                        _item10.height = _item10.offsetHeight;
                    } else if (that.itemHeight !== 'auto') {
                        _item10.height = that.itemHeight;
                        _item10.style.height = _item10.height + 'px';
                    }

                    _item10.top = _item10.offsetTop;
                    scrollHeight += _item10.height;
                }
                scrollHeight = that.$.itemsInnerContainer.scrollHeight - that.$.itemsInnerContainer.offsetHeight;
            }

            return scrollHeight;
        }
    }, {
        key: '_scrollWidth',
        get: function get() {
            var _this4 = this;

            var that = this,
                items = that._items;

            if (that.__scrollWidth) {
                return that.__scrollWidth;
            }

            that.__scrollWidth = function () {
                var that = _this4;
                var longestItemWidth = void 0;

                if (that.isVirtualized) {
                    var longestLabel = '';
                    for (var i = 0; i < items.length; i++) {
                        var label = items[i].label;
                        if (label.length > longestLabel.length) {
                            longestLabel = label;
                        }
                    }

                    var measureItem = that._createItem(that.dataSource[0]);
                    that.$.itemsInnerContainer.appendChild(measureItem);
                    measureItem.label = longestLabel;
                    if (that._areCSSVarsSupported) {
                        that.$.container.setAttribute('style', '--jqx-list-item-inner-container-width: \'auto\'');
                        longestItemWidth = measureItem.offsetWidth;
                        that.$.container.setAttribute('style', '--jqx-list-item-inner-container-width: 100%');
                    } else {
                        that.$.itemsInnerContainer.style.width = '0px';
                        longestItemWidth = measureItem.offsetWidth;
                        that.$.itemsInnerContainer.style.width = '100%';
                    }
                    measureItem.parentNode.removeChild(measureItem);
                    return longestItemWidth;
                }

                if (that._areCSSVarsSupported) {
                    that.$.container.setAttribute('style', '--jqx-list-item-inner-container-width: \'auto\'');
                    longestItemWidth = items[0].offsetWidth;
                    for (var _i14 = 1; _i14 < items.length; _i14++) {
                        longestItemWidth = Math.max(longestItemWidth, items[_i14].offsetWidth);
                    }

                    if (that._groups) {
                        for (var _i15 = 0; _i15 < that._groups.length; _i15++) {
                            longestItemWidth = Math.max(longestItemWidth, that._groups[_i15].offsetWidth);
                        }
                    }

                    that.$.container.setAttribute('style', '--jqx-list-item-inner-container-width: 100%');
                } else {
                    that.$.itemsInnerContainer.style.width = '0px';
                    longestItemWidth = items[0].offsetWidth;
                    for (var _i16 = 1; _i16 < items.length; _i16++) {
                        longestItemWidth = Math.max(longestItemWidth, items[_i16].offsetWidth);
                    }

                    if (that._groups) {
                        for (var _i17 = 0; _i17 < that._groups.length; _i17++) {
                            longestItemWidth = Math.max(longestItemWidth, that._groups[_i17].offsetWidth);
                        }
                    }

                    that.$.itemsInnerContainer.style.width = '100%';
                }

                return longestItemWidth;
            }();

            if (that.__scrollWidth > that.$.itemsContainer.offsetWidth) {
                that._areCSSVarsSupported ? that.$.container.setAttribute('style', '--jqx-list-item-inner-container-width: ' + that.__scrollWidth + 'px') : that.$.itemsInnerContainer.style.width = that.__scrollWidth + 'px';

                return that.__scrollWidth;
            }

            that._areCSSVarsSupported ? that.$.container.setAttribute('style', '--jqx-list-item-inner-container-width: 100%') : that.$.itemsInnerContainer.style.width = '100%';

            return that.__scrollWidth;
        }
    }, {
        key: 'isVirtualized',
        get: function get() {
            var that = this;

            return that.virtualized && that.dataSource && that.dataSource.length > 0;
        }
    }], [{
        key: 'properties',


        /** 
        * ListBox's properties 
        */
        get: function get() {
            return {
                'dataSource': {
                    value: null,
                    type: 'object',
                    reflectToAttribute: false
                },
                'displayLoadingIndicator': {
                    value: false,
                    type: 'boolean'
                },
                'displayMember': {
                    value: '',
                    type: 'string'
                },
                'dropAction': {
                    value: 'move',
                    type: 'string',
                    allowedValues: ['copy', 'move', 'none']
                },
                'filterable': {
                    value: false,
                    type: 'boolean'
                },
                'filterMode': {
                    value: 'startsWithIgnoreCase',
                    allowedValues: ['none', 'contains', 'containsIgnoreCase', 'equals', 'equalsIgnoreCase', 'startsWith', 'startsWithIgnoreCase', 'endsWith', 'endsWithIgnoreCase'],
                    type: 'string'
                },
                'filterInputPlaceholder': {
                    value: '',
                    type: 'string'
                },
                'grouped': {
                    value: false,
                    type: 'boolean'
                },
                'groupMember': {
                    value: '',
                    type: 'string'
                },
                'itemTemplate': {
                    value: null,
                    type: 'string?'
                },
                'itemHeight': {
                    value: null,
                    type: 'number?'
                },
                'incrementalSearchDelay': {
                    value: 700,
                    type: 'number?'
                },
                'incrementalSearchMode': {
                    value: 'startsWithIgnoreCase',
                    allowedValues: ['none', 'contains', 'containsIgnoreCase', 'equals', 'equalsIgnoreCase', 'startsWith', 'startsWithIgnoreCase', 'endsWith', 'endsWithIgnoreCase'],
                    type: 'string'
                },
                'loadingIndicatorPlaceholder': {
                    value: 'Loading...',
                    type: 'string'
                },
                'loadingIndicatorPosition': {
                    value: 'center',
                    allowedValues: ['bottom', 'center', 'top'],
                    type: 'string'
                },
                'messages': {
                    extend: true,
                    value: {
                        'en': {
                            'missingReference': '{{elementType}}: Missing reference to {{files}}.',
                            'overridingProperties': '{{elementType}}: Overriding properties {{property1}} and {{property2}} applied. The "{{property1}}" property is used by default.',
                            'invalidIndex': '{{elementType}}: "{{method}}" method accepts an index of type number or an Array of numbers.',
                            'indexOutOfBound': '{{elementType}}: Out of bound index/indexes in "{{method}}" method.',
                            'invalidItem': '{{elementType}}: "{{method}}" method accepts an object or an array of objects as it\'s second parameter.',
                            'invalidSettings': '{{elementType}}: "{{method}}" method accepts a string or an object as it\'s second parameter.',
                            'htmlTemplateNotSuported': '{{elementType}}: Browser doesn\'t support HTMLTemplate elements.',
                            'invalidTemplate': '{{elementType}}: "{{property}}" property accepts a string that must match the id of an HTMLTemplate element from the DOM.'
                        }
                    },
                    type: 'object'
                },
                'placeholder': {
                    value: 'No Items',
                    type: 'string'
                },
                'reorder': {
                    value: false,
                    type: 'boolean'
                },
                'readonly': {
                    value: false,
                    type: 'boolean'
                },
                'selectedIndexes': {
                    value: [],
                    type: 'array'
                },
                'selectedValues': {
                    value: [],
                    type: 'array'
                },
                'selectionMode': {
                    value: 'default',
                    allowedValues: ['none', 'default', 'zeroOrMany', 'oneOrMany', 'zeroOrOne', 'one', 'checkBox', 'radioButton'],
                    type: 'string'
                },
                'sorted': {
                    value: false,
                    type: 'boolean'
                },
                'valueMember': {
                    value: '',
                    type: 'string'
                },
                'virtualized': {
                    value: false,
                    type: 'boolean'
                }
            };
        }

        /**
         * ListBox's event listeners.
         */

    }, {
        key: 'listeners',
        get: function get() {
            return {
                'focus': '_focusHandler',
                'blur': '_blurHandler',
                'container.wheel': '_mouseWheelHandler',
                'horizontalScrollBar.change': '_horizontalScrollbarHandler',
                'itemsInnerContainer.down': '_downHandler',
                'itemsInnerContainer.move': '_itemsContainerMoveHandler',
                'document.up': '_upHandler',
                'document.move': '_moveHandler',
                'keydown': '_keyDownHandler',
                'keyup': '_keyUpHandler',
                'resize': '_resizeHandler',
                'selectstart': '_selectStartHandler',
                'styleChanged': '_styleChangedHandler',
                'swipeleft': '_swipeLeftHandler',
                'swiperight': '_swipeRightHandler',
                'verticalScrollBar.change': '_verticalScrollbarHandler'
            };
        }
    }]);
    return ListBox;
}(JQX.ContentElement));